import { useMemo } from 'react';

import { collection, CollectionReference, limit, orderBy, query, Query } from 'firebase/firestore';

import { useCollectionData } from 'react-firebase-hooks/firestore';

import { firestore } from '../firebase';
import Email from '../types/Email';

// The most recently queued emails, newest first. Docs queued before createTime was stamped
// don't match the orderBy and are left out.
export default function useEmailOutbox(maxResults = 50) {
  const emailQuery = useMemo(
    () =>
      query(
        collection(firestore, 'email') as CollectionReference<Email>,
        orderBy('createTime', 'desc'),
        limit(maxResults)
      ) as Query<Email>,
    [maxResults]
  );

  const [emails, isEmailsLoading, emailsError] = useCollectionData<Email>(emailQuery);

  return {
    emails: emails ?? [],
    isEmailsLoading,
    emailsError,
  };
}
